const API_HOST = process.env.REACT_APP_API_HOST_URL

const post = async (parameters) => {
  return new Promise((resolve, reject) => {
    fetch(
      `${API_HOST}/distributor/admin/api/v1/inventory/export/box/list`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${parameters.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          isSelectAll: parameters.isSelectAll,
          selectedIds: parameters.selectedIds,
          filter: {
            nodes: parameters.filter.nodes,
            products: parameters.filter.products,
            search: parameters.filter.search,
            search_by: parameters.filter.search_by,
            created_at: parameters.filter.created_at,
            updated_at: parameters.filter.updated_at,
          }
        })
      }
    )
    .then((response) => resolve(response.blob()))
    .catch((error) => reject(error.response.data))
  })
}

export const exportBoxListing = {
  post
}